<template>
  <div class="ms-1 radio-component" v-for="(option, index) in content.options" :key="index">
    <input type="radio" name="contact" :value="option" @change="onChangeHandler" :id="`option${index}`">
    <label :for="`option${index}`">{{ option }}</label>
  </div>
</template>
<script>
    export default {
        name: "RadioComponent",
        props:{
            content: Object,
            idx: Number,
        },
        methods : {
          onChangeHandler : function (event) {
            console.log(event.target)
            this.$emit('responseevent', {id: this.$props.idx, response: event.target.value})
          }
        }
    }
</script>